import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export const FloatingWhatsapp = () => (
  <a
    href={SITE.whatsappUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Order on WhatsApp"
    className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-brand-primary hover:bg-brand-primaryHover text-brand-base flex items-center justify-center shadow-[0_8px_28px_-8px_rgba(28,59,36,0.5)] hover:-translate-y-1 transition-all duration-300"
  >
    <span className="absolute inline-flex h-full w-full rounded-full bg-brand-accent opacity-30 animate-ping" />
    <MessageCircle size={22} strokeWidth={1.8} className="relative" />
  </a>
);

export default FloatingWhatsapp;
